function start_report(id) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: `/reports/start/${id}`,
        onOpen: function (elm, popup) {
            elm.find('[data-company-selector]').companySelector();
            elm.find('[data-contact-selector]').contactSelector();
            elm.find('[data-course-selector]').courseSelector();
            elm.find('[data-product-selector]').productSelector();


            elm.find('form').submit(function () {
                popup.close();
            });
        }
    });
    return false;
}
function create_report() {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/reports/create',
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(() => {
                squde_reload_for_flashes();
                reload_location_if_needed(true);
            })
        }
    });
    return false;
}
function view_report(id) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: `/reports/view/${id}`,
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(() => {
                squde_reload_for_flashes();
                reload_location_if_needed(true);
            })
        }
    });
    return false;
}
